// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsInteractionBar-cls1___f77033360d891d9ea68{/*!*/}.NewsInteractionBar-cls2___4dfcdca6f2623649b91{position:absolute;left:100%;top:50%;transform:translateY(-50%);line-height:20px;margin-left:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsInteractionBar-cls1___f77033360d891d9ea68",
	"cls2": "NewsInteractionBar-cls2___4dfcdca6f2623649b91 NewsInteractionBar-cls1___f77033360d891d9ea68"
};
export default ___CSS_LOADER_EXPORT___;
